import axios from 'axios'

export default {
    users() {
        return axios.get('api/load-toplist-users')
    },
}
